import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private isProduction = environment.production;
  private isHomolog = environment.homolog;

  log(message: string, ...optionalParams: any[]): void {
    if (!this.isProduction && !this.isHomolog) {
      console.log(message, ...optionalParams);
    }
  }

  error(message: string, ...optionalParams: any[]): void {
    console.error(message, ...optionalParams);
  }

  warn(message: string, ...optionalParams: any[]): void {
    if (!this.isProduction && !this.isHomolog) {
      console.warn(message, ...optionalParams);
    }
  }

  info(message: string, ...optionalParams: any[]): void {
    if (!this.isProduction && !this.isHomolog) {
      console.info(message, ...optionalParams);
    }
  }
}
